module.exports = __webpack_public_path__ + "img/payroll.5f65ec06.svg";